import React, { useState, useEffect, useCallback } from "react";
import { Routes, Route, NavLink, Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Menu, Dropdown, Avatar, Button, Badge, Input } from "antd";
import {
  HomeOutlined,
  BookOutlined,
  InfoCircleOutlined,
  PhoneOutlined,
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  ShoppingOutlined,
  SearchOutlined, AppstoreAddOutlined, HeartOutlined
} from "@ant-design/icons";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import Profile from "./components/Profile";
import BoardUser from "./components/BoardUser";
import BoardModerator from "./components/BoardModerator";
import BoardAdmin from "./components/BoardAdmin";
import Courses from "./components/cours/Courses";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import BecomeInstructor from "./components/becomeinstructor/BecomeInstructor";

import { logout } from "./actions/auth";
import Card from "antd/es/card/Card";
import CourseCreateForm from "./components/moderateur/CourseCreateForm";
import ModeratorCourses from "./components/moderateur/ModeratorCourses";
import AddSubjectForm from "./components/moderateur/AddSubjectForm";
import MyPurchases from "./components/user/MyPurchases";
// import CourseDetails from "./components/user/CourseOverview";
import CourseDetails from "./components/user/CourseDetails"; // ✅ Le vrai composant parent

const { Search } = Input;

const App = () => {
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [cartItems, setCartItems] = useState(3);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const handleEditSubject = (subject) => {
    setSelectedSubject(subject);
    setIsEditingSubject(true);
  };


  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOut = useCallback(() => {
    dispatch(logout());
    navigate("/login");
  }, [dispatch, navigate]);

  useEffect(() => {
    if (currentUser) {
      setShowModeratorBoard(currentUser.roles.includes("ROLE_MODERATOR"));
      setShowAdminBoard(currentUser.roles.includes("ROLE_ADMIN"));
    } else {
      setShowModeratorBoard(false);
      setShowAdminBoard(false);
    }
  }, [currentUser]);

  // Menu déroulant pour le profil
  // const profileMenu = (
  //   <Menu>
  //     <Menu.Item key="user-info" disabled style={{ cursor: "default" }}>
  //       <div style={{ textAlign: "center" }}>
  //         <strong>{currentUser?.username}</strong>
  //         <br />
  //         <small>{currentUser?.email}</small>
  //       </div>
  //     </Menu.Item>
  //     <Menu.Divider />
  //     {showAdminBoard && (
  //       <Menu.Item key="dashboard" icon={<SettingOutlined />}>
  //         <Link to="/admin">Interface Admin</Link>
  //       </Menu.Item>
  //     )}
  //     {showModeratorBoard && (
  //       <Menu.Item key="moderator-dashboard" icon={<SettingOutlined />}>
  //         <Link to="/mod">Tableau Modérateur</Link>
  //       </Menu.Item>
  //     )}
  //     <Menu.Item key="courses" icon={<ShoppingOutlined />}>
  //       Mes Apprentissages
  //     </Menu.Item>
  //     <Menu.Item key="purchases" icon={<ShoppingOutlined />}>
  //       Mes Achats
  //     </Menu.Item>
  //     <Menu.Item key="wishlist" icon={<SettingOutlined />}>
  //       Liste de Souhaits
  //     </Menu.Item>
  //     <Menu.Divider />
  //     <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logOut}>
  //       Déconnexion
  //     </Menu.Item>
  //   </Menu>
  // );
  const profileMenu = (
    <Menu>
      {/* Informations utilisateur */}
      <Menu.Item key="user-info" disabled style={{ cursor: "default" }}>
        <div style={{ textAlign: "center" }}>
          <Avatar
            size={64}
            style={{
              backgroundColor: showAdminBoard
                ? "#f56a00"
                : showModeratorBoard
                  ? "#87d068"
                  : "#1890ff",
              marginBottom: "10px",
            }}
            icon={<UserOutlined />}
          />
          <div>
            <strong>{currentUser?.username}</strong>
            <br />
            <small>{currentUser?.email}</small>
          </div>
        </div>
      </Menu.Item>
      <Menu.Divider />
      {/* Options spécifiques pour l'administrateur */}
      {showAdminBoard && (
        <>
          <Menu.Item key="admin-dashboard" icon={<SettingOutlined />}>
            <Link to="/admin">Interface Admin</Link>
          </Menu.Item>
          <Menu.Item key="manage-users" icon={<TeamOutlined />}>
            <Link to="/admin/users">Gérer les Utilisateurs</Link>
          </Menu.Item>
        </>
      )}
      {/* Options spécifiques pour le modérateur */}
      {showModeratorBoard && (
        <>
          {/* <Menu.Item key="moderator-dashboard" icon={<SettingOutlined />}>
            <Link to="/mod">Tableau Modérateur</Link>
          </Menu.Item> */}
          <Menu.Item key="manage-courses" icon={<BookOutlined />}>
            <Link to="/mod/courses">Mes Cours</Link>
          </Menu.Item>
          <Menu.Item key="create-course" icon={<AppstoreAddOutlined />}>
            <Link to="/mod/create-course">Créer un Nouveau Cours</Link>
          </Menu.Item>
          {/* <Menu.Item key="students" icon={<UserOutlined />}>
            <Link to="/mod/students">Mes Apprenants</Link>
          </Menu.Item> */}
        </>
      )}
      {/* Options communes */}
      {/* <Menu.Item key="courses" icon={<ShoppingOutlined />}>
        <Link to="/learning">Mes Apprentissages</Link>
      </Menu.Item> */}
      <Menu.Item key="purchases" icon={<ShoppingOutlined />}>
        <Link to="/my-purchases">Mes Achats</Link>
      </Menu.Item>
      {/* <Menu.Item key="wishlist" icon={<HeartOutlined />}>
        <Link to="/wishlist">Liste de Souhaits</Link>
      </Menu.Item> */}
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logOut}>
        Déconnexion
      </Menu.Item>

    </Menu>
  );

  // Menu pour connexion / inscription
  const loginMenu = (
    <Menu>
      <Menu.Item key="login">
        <Link to="/login">Connexion</Link>
      </Menu.Item>
      <Menu.Item key="register">
        <Link to="/register">Créer un compte</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>

      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top" style={{ zIndex: 1000 }}>
        <div className="container-fluid">
          <Link to={"/"} className="navbar-brand">
            <img src="/img/nomidya.png" alt="Nomidya" style={{ height: "40px" }} />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarContent">
            {/* <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-3 text-center"> */}
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-4">

              <li className="nav-item">
                <NavLink to="/home" className="nav-link"><HomeOutlined /> Accueil</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/courses" className="nav-link"><BookOutlined /> Cours</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className="nav-link"><InfoCircleOutlined /> À Propos</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/contact" className="nav-link"><PhoneOutlined /> Contact</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/become-instructor" className="nav-link"><TeamOutlined /> Formateur</NavLink>
              </li>
            </ul>


            {/* Zone droite : recherche + actions */}
            <div className="d-flex align-items-center flex-wrap gap-2">
              <Search
                placeholder="Rechercher des Cours..."
                allowClear
                enterButton={<SearchOutlined />}
                size="middle"
                style={{ width: "250px" }} // ou "300px"
              />


              <Badge count={cartItems} size="small">
                <Button
                  icon={<ShoppingOutlined />}
                  type="text"
                  style={{ fontSize: "18px", color: "#000" }}
                />
              </Badge>

              {currentUser ? (
                <Dropdown overlay={profileMenu} placement="bottomRight">
                  <Button
                    icon={
                      <Avatar
                        style={{ backgroundColor: showAdminBoard ? "#f56a00" : "#87d068" }}
                        icon={<UserOutlined />}
                      />
                    }
                    type="text"
                    style={{ color: "black" }}
                  >
                    {currentUser.username}
                  </Button>
                </Dropdown>
              ) : (
                <Dropdown overlay={loginMenu} placement="bottomRight">
                  <Button type="primary">Connexion</Button>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      </nav>

      <Card>
        <div className="custom-container mt-3">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<Profile />} />

            <Route path="/admin" element={<BoardAdmin />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/become-instructor" element={<BecomeInstructor />} />
            <Route path="/mod/create-course" element={<CourseCreateForm />} />

            {/* Dashboard Modérateur */}
            <Route path="/mod" element={<BoardModerator />} />

            {/* Mes cours */}
            <Route path="/mod/courses" element={<ModeratorCourses />} />
            <Route path="/user" element={<BoardUser />} />
            <Route path="/mod" element={<BoardModerator />} />

            {/* Modifier un cours */}
            <Route
              path="/mod/courses/edit/:courseId"
              element={<CourseCreateForm btnText="Modifier le cours" />}
            />

            {/* Ajouter un sujet */}
            <Route
              path="/mod/courses/:courseId/add-subject"
              element={<AddSubjectForm />}
            />


            {/* Mes achats et cours achetés */}
            <Route path="/my-purchases" element={<MyPurchases />} />
            <Route
              path="/learning/course/:id"
              element={<CourseDetails />}
            />

          </Routes>
        </div>
      </Card>
    </div>
  );
};

export default App;



